import request from '@/utils/request'

const tradeContractAttachmentApi = {
  trade_contract_attachment_list: '/trade/contract_attachment/',
  trade_contract_attachment_create: '/trade/contract_attachment/',
  trade_contract_attachment_update: '/trade/contract_attachment/',
  trade_contract_attachment_delete: '/trade/contract_attachment/',
  trade_storage_contract_attachment: '/trade/storage_contract_attachment/',
  trade_insurance_contract_attachment: '/trade/insurance_contract_attachment/',
  trade_charter_party_contract_attachment: '/trade/charter_party_contract_attachment/',
  trade_booking_contract_attachment: '/trade/booking_contract_attachment/',
  trade_inspection_contract_attachment: '/trade/inspection_contract_attachment/',
  trade_freight_forwarding_contract_attachment: '/trade/freight_forwarding_contract_attachment/',
  trade_loading_supervision_contract_attachment: '/trade/loading_supervision_contract_attachment/',
  trade_supervision_contract_attachment: '/trade/supervision_contract_attachment/'
}

/**
 * 列表
 */
export function contract_attachment_list (parameter) {
  return request({
    url: tradeContractAttachmentApi.trade_contract_attachment_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function contract_attachment_create (parameter) {
  return request({
    url: tradeContractAttachmentApi.trade_contract_attachment_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function contract_attachment_update (parameter, contract_attachment_id) {
  return request({
    url: tradeContractAttachmentApi.trade_contract_attachment_update + contract_attachment_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function contract_attachment_delete (contract_attachment_id) {
  return request({
    url: tradeContractAttachmentApi.trade_contract_attachment_delete + contract_attachment_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
* 仓储合同附件列表
* @param parameter
* @returns {AxiosPromise}
*/
export function storage_contract_attachment_list (parameter) {
  return request({
    url: tradeContractAttachmentApi.trade_storage_contract_attachment,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 仓储合同附件添加
 */
export function storage_contract_attachment_create (parameter) {
  return request({
    url: tradeContractAttachmentApi.trade_storage_contract_attachment,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 仓储合同附件删除
 */
export function storage_contract_attachment_delete (contract_attachment_id) {
  return request({
    url: tradeContractAttachmentApi.trade_storage_contract_attachment + contract_attachment_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 保险合同附件列表
 * @param parameter
 * @returns {AxiosPromise}
 */
export function insurance_contract_attachment_list (parameter) {
  return request({
    url: tradeContractAttachmentApi.trade_insurance_contract_attachment,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 保险合同附件添加
 */
export function insurance_contract_attachment_create (parameter) {
  return request({
    url: tradeContractAttachmentApi.trade_insurance_contract_attachment,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 保险合同附件删除
 */
export function insurance_contract_attachment_delete (contract_attachment_id) {
  return request({
    url: tradeContractAttachmentApi.trade_insurance_contract_attachment + contract_attachment_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 租船合同附件列表
 * @param parameter
 * @returns {AxiosPromise}
 */
export function charter_party_contract_attachment_list (parameter) {
  return request({
    url: tradeContractAttachmentApi.trade_charter_party_contract_attachment,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 租船合同附件添加
 */
export function charter_party_contract_attachment_create (parameter) {
  return request({
    url: tradeContractAttachmentApi.trade_charter_party_contract_attachment,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 租船合同附件删除
 */
export function charter_party_contract_attachment_delete (contract_attachment_id) {
  return request({
    url: tradeContractAttachmentApi.trade_charter_party_contract_attachment + contract_attachment_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
/**
 * 订舱合同附件列表
 * @param parameter
 * @returns {AxiosPromise}
 */
export function booking_contract_attachment_list (parameter) {
  return request({
    url: tradeContractAttachmentApi.trade_booking_contract_attachment,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 订舱合同附件添加
 */
export function booking_contract_attachment_create (parameter) {
  return request({
    url: tradeContractAttachmentApi.trade_booking_contract_attachment,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 订舱合同附件删除
 */
export function booking_contract_attachment_delete (contract_attachment_id) {
  return request({
    url: tradeContractAttachmentApi.trade_booking_contract_attachment + contract_attachment_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 商检合同附件列表
 * @param parameter
 * @returns {AxiosPromise}
 */
export function inspection_contract_attachment_list (parameter) {
  return request({
    url: tradeContractAttachmentApi.trade_inspection_contract_attachment,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 商检合同附件添加
 */
export function inspection_contract_attachment_create (parameter) {
  return request({
    url: tradeContractAttachmentApi.trade_inspection_contract_attachment,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 商检合同附件删除
 */
export function inspection_contract_attachment_delete (contract_attachment_id) {
  return request({
    url: tradeContractAttachmentApi.trade_inspection_contract_attachment + contract_attachment_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 货代合同附件列表
 * @param parameter
 * @returns {AxiosPromise}
 */
export function freight_forwarding_contract_attachment_list (parameter) {
  return request({
    url: tradeContractAttachmentApi.trade_freight_forwarding_contract_attachment,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 货代合同附件添加
 */
export function freight_forwarding_contract_attachment_create (parameter) {
  return request({
    url: tradeContractAttachmentApi.trade_freight_forwarding_contract_attachment,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 货代合同附件删除
 */
export function freight_forwarding_contract_attachment_delete (contract_attachment_id) {
  return request({
    url: tradeContractAttachmentApi.trade_freight_forwarding_contract_attachment + contract_attachment_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 监装合同附件列表
 * @param parameter
 * @returns {AxiosPromise}
 */
export function loading_supervision_contract_attachment_list (parameter) {
  return request({
    url: tradeContractAttachmentApi.trade_loading_supervision_contract_attachment,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 监装合同附件添加
 */
export function loading_supervision_contract_attachment_create (parameter) {
  return request({
    url: tradeContractAttachmentApi.trade_loading_supervision_contract_attachment,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 监装合同附件删除
 */
export function loading_supervision_contract_attachment_delete (contract_attachment_id) {
  return request({
    url: tradeContractAttachmentApi.trade_loading_supervision_contract_attachment + contract_attachment_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 监管合同附件列表
 * @param parameter
 * @returns {AxiosPromise}
 */
export function supervision_contract_attachment_list (parameter) {
  return request({
    url: tradeContractAttachmentApi.trade_supervision_contract_attachment,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 监管合同附件添加
 */
export function supervision_contract_attachment_create (parameter) {
  return request({
    url: tradeContractAttachmentApi.trade_supervision_contract_attachment,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 监管合同附件删除
 */
export function supervision_contract_attachment_delete (contract_attachment_id) {
  return request({
    url: tradeContractAttachmentApi.trade_supervision_contract_attachment + contract_attachment_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
